// Apolo IDE — useBranchPr (Pedro 2026-06-25, sprint cursor-strip-4 round 7).
//
// Busca DETERMINÍSTICA da PR aberta de um branch específico via Worker
// (/api/github/branch-pr). Substitui a heurística frágil de casar head_ref
// dentro de code.prs (que só enriquece os 10 primeiros da busca involves:).
//
// API: { pr, loading, error, refresh }
//   pr = { number, html_url, title, state, draft } | null
// Não busca sem owner+repo+branch. Re-busca quando o branch muda.

import { useCallback, useEffect, useRef, useState } from 'react';
import { apiFetch } from '../lib/api.js';

export function useBranchPr({ owner, repo, branch, enabled = true } = {}) {
  const [pr, setPr] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const abortRef = useRef(null);

  const fetchOnce = useCallback(async () => {
    if (!owner || !repo || !branch) {
      setPr(null);
      return;
    }
    abortRef.current?.abort?.();
    const ac = new AbortController();
    abortRef.current = ac;
    setLoading(true);
    try {
      const qs = new URLSearchParams({ owner, repo, branch }).toString();
      const res = await apiFetch(`/api/github/branch-pr?${qs}`, { signal: ac.signal });
      if (!res.ok) {
        // 404 GITHUB_NOT_CONNECTED é estado honesto (sem token) → sem PR, sem erro de UI.
        if (res.status !== 404) setError(res.error || `HTTP ${res.status}`);
        setPr(null);
        return;
      }
      setPr(res.data?.pr ?? null);
      setError(null);
    } catch (e) {
      if (e?.name === 'AbortError') return;
      setError(e?.message || 'Falha ao buscar PR do branch');
      setPr(null);
    } finally {
      if (!ac.signal.aborted) setLoading(false);
    }
  }, [owner, repo, branch]);

  useEffect(() => {
    if (!enabled) return undefined;
    fetchOnce();
    return () => abortRef.current?.abort?.();
  }, [enabled, fetchOnce]);

  return { pr, loading, error, refresh: fetchOnce };
}

export default useBranchPr;
